import isAdmin from './isAdmin';
import isOwner from './isOwner';
import isProgramManager from './isProgramManager';
import isProgramTrainer from './isProgramTrainer';
import isStudent from './isStudent';
import isSuperAdmin from './isSuperAdmin';
import isTeacher from './isTeacher';

const roleReadable = (role = [], orgType = '') => {
  switch (true) {
    case isSuperAdmin(role):
      return 'Super Admin';
    case isOwner(role):
      return 'Owner';
    case isAdmin(role):
      return 'Admin';
    case isProgramTrainer(role):
      return 'Program Trainer';
    case isProgramManager(role):
      return 'Program Manager';
    case isTeacher(role):
      return orgType === 'workforce' ? 'Expert' : 'Instructor';
    case isStudent(role):
      return orgType === 'workforce' ? 'User' : 'Trainee';
    default:
      return role.join(',');
  }
};

export default roleReadable;
